import { useForm as useFormHook } from "hooks";
import useValidationSchema from "./useValidationSchema";
import {
    FormField,
    type OnboardingCompleteOnboaring,
    type OnboardingCompleteOnboaringForm
} from "./types";
import { BooleanSwitchValue } from "consts/general";

export const getInitialValues = (
    initialValues: Partial<OnboardingCompleteOnboaring>
): OnboardingCompleteOnboaring => ({
    [FormField.HasAgreedTermsConditions]: BooleanSwitchValue.Off,
    ...initialValues
});

export const useForm = (onboardingCompleteOnbarding: OnboardingCompleteOnboaringForm) =>
    useFormHook({
        isInitialValid: false,
        validateOnMount: true,
        ...onboardingCompleteOnbarding,
        validationSchema: useValidationSchema()
    });
